import React, { useEffect, useState } from 'react';
import moment from "moment";
import { PlanoVinculadoEntidade } from '@entidades';

import { LoadingComponent } from '@components';
import { Alert, Box, Col, Row, StaticField } from '@intech/web-ui';
import { FuncionarioService, SimuladorAposentadoriaService } from '@services';
import { Card } from '../Card';
import { Link } from 'react-router-dom';

interface IProps {
  Plano: PlanoVinculadoEntidade;
}

export const ProjecoesBeneficiosTeoricos: React.FC<IProps> = ({
  Plano
}) => {

  const [AlertText, setAlertText] = useState<string>("");

  const [IdadeAposentadoriaData, setIdadeAposentadoriaData] = useState<string>("");
  const [IdadeAposentadoriaCompleta, setIdadeAposentadoriaCompleta] = useState<string>("");
  const [IdadeCompleta, setIdadeCompleta] = useState<string>("");

  const [DataAtual, setDataAtual] = useState<string>("");

  const [FatorAtuarialAT83, setFatorAtuarialAT83] = useState<number>(0);
  const [FatorAtuarialPrazoCerto, setFatorAtuarialPrazoCerto] = useState<number>(0);
  const [Saldo, setSaldo] = useState<number>(0);

  const [SaldoPrazoCerto, setSaldoPrazoCerto] = useState<number[]>([]);
  const [MesesPrazoCerto, setMesesPrazoCerto] = useState<number[]>([
    120, 240, 360, 480, 600
  ]);

  useEffect(() => {
    (async () => {
      try {
        const Rentabilidade = 3.5;

        const Contribuicao = 0;

        const dados = await FuncionarioService.Buscar();

        const Idade = parseInt(dados.IDADE, 10);
        const IdadeMinima = dados.SEXO === "FEMININO" ? 53 : 55;
        const IdadeAposentadoria = (Idade > IdadeMinima ? Idade : IdadeMinima);

        const DatasAposentadoria = await SimuladorAposentadoriaService.BuscarIdadeAposentadoria(IdadeAposentadoria);
        setIdadeAposentadoriaData(moment(DatasAposentadoria.DataAposentadoria, "DD/MM/YYYY").format("DD/MM/YYYY"));
        setIdadeAposentadoriaCompleta(DatasAposentadoria.Idade);

        const IdadeCompleta = await FuncionarioService.BuscarIdadeCompleta();
        setIdadeCompleta(IdadeCompleta);

        setDataAtual(moment().format("DD/MM/YYYY"));

        const FatorAtuarialAT83 = await SimuladorAposentadoriaService.BuscarFatorAtuarialAT83(IdadeAposentadoria, Rentabilidade);

        setFatorAtuarialAT83(FatorAtuarialAT83);

        const Saldo = await SimuladorAposentadoriaService.CalcularSaldoAposentadoria(Plano.CD_PLANO, IdadeAposentadoria, Rentabilidade, Contribuicao);

        setSaldo(Saldo);

        let SaldosPorPrazos: number[] = [];

        for (let Prazo = 0; Prazo < MesesPrazoCerto.length; Prazo++) {
          const FatorAtuarialPrazoCerto = await SimuladorAposentadoriaService.BuscarFatorAtuarialPrazoCerto(MesesPrazoCerto[Prazo], Rentabilidade);

          const SaldoPorPrazo = (Saldo / FatorAtuarialPrazoCerto);

          SaldosPorPrazos.push(SaldoPorPrazo);
        }

        setSaldoPrazoCerto(SaldosPorPrazos);

      }
      catch (err) {
        const error = err.response ? err.response.data : err;
        setAlertText(error || "Erro ao carregar o simulador, tente novamente mais tarde.");
      }
    })();
  }, []);

  function ToMoney(Valor: number) {
    return (
      Valor.toLocaleString('pt-br', { minimumFractionDigits: 2 })
    );
  }

  if (Saldo > 0 && SaldoPrazoCerto.length === 5) {
    return (
      <Box title={"Projeções dos Benefícios Teóricos (Previsão)"}>

        <Row>
          <Col>
            <Card titulo={"Data Prevista Para Aposentadoria Integral"}>
              {IdadeAposentadoriaData}
            </Card>
          </Col>

          <Col>
            <Card titulo={"Idade na Aposentadoria Integral"}>
              {IdadeAposentadoriaCompleta}
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card titulo={"Provisão Matemática Programada (Projetada)"}>
              <StaticField value={Saldo} type={"money"} />
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card titulo={"Valores de Benefícios Projetados"}>

              <Row>
                <Col>
                  <Card titulo={"Benefício Inicial por Prazo Certo com recebimento (1)"}>
                    {`em ${MesesPrazoCerto[0]} meses: `}<StaticField value={SaldoPrazoCerto[0]} type={"money"} />
                    <br />
                    {`em ${MesesPrazoCerto[1]} meses: `}<StaticField value={SaldoPrazoCerto[1]} type={"money"} />
                    <br />
                    {`em ${MesesPrazoCerto[2]} meses: `}<StaticField value={SaldoPrazoCerto[2]} type={"money"} />
                    <br />
                    {`em ${MesesPrazoCerto[3]} meses: `}<StaticField value={SaldoPrazoCerto[3]} type={"money"} />
                    <br />
                    {`em ${MesesPrazoCerto[4]} meses: `}<StaticField value={SaldoPrazoCerto[4]} type={"money"} />
                  </Card>
                </Col>

                <Col>
                  <Card titulo={"Benefícios Inicial Renda Anualmente Ajustável (2)"}>
                    <StaticField value={Saldo / FatorAtuarialAT83} type={"money"} />
                  </Card>
                </Col>
              </Row>

            </Card>
          </Col>
        </Row>

        <div className={"alert alert-info"}>
          <b>{"Importante:"}</b>
          <br />
          {"Projeções realizadas para a data de aposentadoria integral: 53 anos para sexo Feminino, 55 anos para o sexo masculino."}
          <br /><br />
          {"Esta simulação foi efetuada estimando uma rentabilidade de 3.5% ao ano durante a acumulação e após a concessão do benefício."}
          <br /><br />
          {"(1) Renda Mensal por Prazo Certo, calculada na data de concessão, a partir do saldo registrado na Provisão Matemática de Benefício Concedido do Participante, a ser paga pelo prazo de “n” meses, podendo “n”, a critério do participante, ser definido entre o mínimo de 120 (cento e vinte) e o máximo de 600 (seiscentos) meses, sendo o valor da renda mensal inicial estabelecida de acordo com a Nota Técnica Atuarial do Plano, e o valor a ser pago a cada novo mês será igual ao valor pago no mês anterior, atualizado pelo valor da cota prevista art. 42, vezes o fator de ajuste."}
          <br /><br />
          {"(2) Renda Mensal Anualmente Ajustável, calculada atuarialmente na data de concessão, a partir do saldo registrado na Provisão Matemática de Benefício Concedido do Participante, da sua idade e da expectativa de sua sobrevivência, com base em Tábua de Mortalidade e de taxa de juros real, estabelecidas de acordo com a Nota Técnica Atuarial do Plano e recalculada atuarialmente, após a concessão, no mês de novembro de cada ano;"}
          <br /><br />
          {"Para entrar em contato conosco, favor enviar e-mail para: faelce@faelce.com.br ou utilize "}

          <Link className={"btn btn-primary"} to={"relacionamento"}>nossa central de atendimento</Link>
        </div>

        {AlertText !== "" && <Alert type={"danger"}>
          {AlertText}
        </Alert>}

      </Box>
    );
  }

  return <LoadingComponent />;
}